import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=e052772a&scoped=true"
import script from "./no-content.vue?vue&type=script&lang=ts"
export * from "./no-content.vue?vue&type=script&lang=ts"
import style0 from "./no-content.vue?vue&type=style&index=0&id=e052772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052772a",
  null
  
)

export default component.exports